/// <reference path="@popperjs/core/index.d.ts" /

/**
 * Set gap between popper and referenced element
 * @See https://popper.js.org/docs/v2/modifiers/offset/
 * @param {number} gapInPixel
 * @returns {object}
 */
function createOffsetModifier() {
  var gapInPixel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  return {
    name: 'offset',
    options: {
      offset: [0, gapInPixel]
    }
  };
}
/**
 * Make popper width equals to reference/activator width,
 * unless popper width is wider.
 * @See https://popper.js.org/docs/v2/modifiers/community-modifiers/
 * @returns {object}
 */


function createSameWidthModifier() {
  return {
    name: "sameWidthAsReference",
    enabled: true,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn: _ref => {
      var {
        state
      } = _ref;
      var {
        popper,
        reference
      } = state.rects || {};

      if (!popper || !reference) {
        return;
      }

      if (popper.width >= reference.width) {
        return;
      }

      state.styles.popper.width = "".concat(reference.width, "px");
    },
    effect: _ref2 => {
      var {
        state
      } = _ref2;
      var {
        popper,
        reference
      } = state.elements;

      if (!popper || !reference) {
        return;
      }

      if (popper.offsetWidth >= reference.offsetWidth) {
        return;
      }

      popper.style.width = "".concat(reference.offsetWidth, "px");
    }
  };
}

export default {
  strategy: 'fixed',
  placement: 'bottom',
  modifiers: [createOffsetModifier(8), createSameWidthModifier()]
};